import { render } from "./QuestionSelectDeletePartners.vue?vue&type=template&id=4af4b1c2&scoped=true&ts=true"
import script from "./QuestionSelectDeletePartners.vue?vue&type=script&lang=ts"
export * from "./QuestionSelectDeletePartners.vue?vue&type=script&lang=ts"

import "./QuestionSelectDeletePartners.vue?vue&type=style&index=0&id=4af4b1c2&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4af4b1c2"]])

export default __exports__